import { useTranslation } from 'react-i18next';
import { RankPatentBadge } from '@/components/ranks/RankPatentBadge';

export type SeasonTitleItem = {
  season_id: string;
  season_name: string;
  title_id?: string | null;
  placement?: number | null;
};

export function SeasonTitlesList({ titles }: { titles: SeasonTitleItem[] }) {
  const { t } = useTranslation();

  if (titles.length === 0) {
    return null;
  }

  return (
    <ul className="space-y-2">
      {titles.map((title) => (
        <li
          key={title.season_id}
          className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm"
        >
          <span className="font-medium">{title.season_name}</span>
          {title.title_id ? (
            <RankPatentBadge
              tierId={title.title_id}
              size="sm"
              seasonName={title.season_name}
            />
          ) : null}
          {title.placement != null ? (
            <span className="text-muted-foreground">
              {t('ranks.placement', { placement: title.placement })}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
